import { ZEE5_BASE_ADDRESS } from './ApiConstants';

export const AppsflyerWebKey = 'a3a01217-3dc6-4b15-bcb7-8b22097fe9b9';
export const AppsflyerBannerKey = '030dd7f7-2896-4faf-b1f6-47c9558aafe4';
export const SEARCH_MUSIC = 'music';
export const VOICE_SEARCH_DEFAULT_LANGUAGE = 'English (United Kingdom)';
export const GRANTED = 'granted';
export const DENIED = 'denied';
export const NEW_SEARCH_REVAMP = true;
//Splash image url
export const SPLASH_IMAGE_URL = 'https://www.zee5.com/assets/common/Splash.jpg';
//OgTags
//TODO: remove unused constants
export const META_OG_TYPE = 'website';
export const META_OG_SITE_NAME = 'ZEE5';
export const META_OG_TWITTER_CARD = 'summary_large_image';
export const META_OG_TWITTER_CARD_PLAY_COLLECTION = 'photo';
export const META_OG_TWITTER_SITE = '@ZEE5India';
export const FACEBOOK_APP_ID = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID;

export const BASE_URL = process.env.NEXT_PUBLIC_ZEE5_BASE_ADDRESS;
export const GLOBAL_BASE_URL = `${process.env.NEXT_PUBLIC_ZEE5_BASE_ADDRESS}/global`;

export const SCHEMA_SITE_URL = 'http://schema.org/';
export const SCHEMA_TVSERIES_TYPE = 'TVSeries';
export const SCHEMA_VIDEO_OBJECT_TYPE = 'VideoObject';
export const SCHEMA_ACTOR_PERSON_TYPE = 'Person';
export const SCHEMA_TV_SEASON_TYPE = 'TVSeason';
export const SCHEMA_PUBLICATION_EVENT_TYPE = 'PublicationEvent';
export const SCHEMA_EVENT = 'Event';
export const SCHEMA_WATCH_ACTION_TYPE = 'WatchAction';
export const SCHEMA_ENTRY_POINT_TYPE = 'EntryPoint';
export const SCHEMA_OFFER_TYPE = 'Offer';
export const SCHEMA_COUNTRY_TYPE = 'Country';
export const SCHEMA_CORPORATION_TYPE = 'Corporation';
export const SCHEMA_SEARCH_ACTION_TYPE = 'SearchAction';
export const SCHEMA_DESKTOP_WEB_PLATFORM = `${SCHEMA_SITE_URL}DesktopWebPlatform`;
export const SCHEMA_MOBILE_WEB_PLATFORM = `${SCHEMA_SITE_URL}MobileWebPlatform`;
export const SCHEMA_IOS_PLATFORM = `${SCHEMA_SITE_URL}IOSPlatform`;
export const SCHEMA_ANDROID_PLATFORM = `${SCHEMA_SITE_URL}AndroidPlatform`;
export const SCHEMA_ANDROID_TV_PLATFORM = `${SCHEMA_SITE_URL}AndroidTVPlatform`;
export const SCHEMA_GOOGLE_VIDEO_CAST =
  'http://schema.googleapis.com/GoogleVideoCast';
export const SCHEMA_FACEBOOK_URL = 'https://www.facebook.com/ZEE5/';
export const SCHEMA_TWITTER_URL = 'https://twitter.com/zee5india';
export const SCHEMA_INSTAGRAM_URL =
  process.env.NEXT_PUBLIC_SCHEMA_INSTAGRAM_URL;
export const SCHEMA_LINKEDIN_URL = process.env.NEXT_PUBLIC_SCHEMA_LINKEDIN_URL;
export const SCHEMA_YOUTUBE_CHANNEL_URL =
  process.env.SCHEMA_YOUTUBE_CHANNEL_URL;
// export const SCHEMA_SEARCH_QUERY_URL = `${process.env.NEXT_PUBLIC_ZEE5_BASE_ADDRESS}search/result?q={search_term_string}`;
export const SCHEMA_QUERY_INPUT = 'required name=search_term_string';
export const SCHEMA_LOGO_URL = `${process.env.NEXT_PUBLIC_ZEE5_BASE_ADDRESS}assets/common/ZEE5_Logo50x50.png`;
export const SCHEMA_DESCRIPTION =
  '100,000+ hours of TV Shows from ZEE network, Movies, International & Original content, music online in the language of your choice. Watch 90+ Live TV channels online including News anytime, anywhere on ZEE5 – where you feel the entertainment come alive!';
export const SCHEMA_TELEVISION_CHANNEL_TYPE = 'TelevisionChannel';
export const SCHEMA_NEWS_NAME = process.env.NEXT_PUBLIC_SCHEMA_NEWS_NAME;
export const SCHEMA_BROADCAST_CHANNEL_ID = '1';
export const SCHEMA_BROADCAST_TIER = 'Premium';
export const SCHEMA_BROADCAST_LINEUP_TYPE = 'CableOrSatelliteService';
export const SCHEMA_BROADCAST_LINEUP_NAME = 'Cable & Satellite';
export const SCHEMA_BROADCAST_SERVICE_TYPE = 'BroadcastService';
export const SCHEMA_BROADCAST_SERVICE_NAME = 'Zee News TV';
export const SCHEMA_BROADCAST_DISPLAY_NAME =
  process.env.NEXT_PUBLIC_SCHEMA_NEWS_NAME;
export const SCHEMA_BROADCAST_AFFILIATE_TYPE = 'Organization';
export const SCHEMA_BROADCAST_AFFILIATE_NAME = 'Zee TV';
export const CAROUSEL_ITEMS_LIMIT = 7;
export const PAGINATION_ITEMS_LIMIT = 25;
export const SCHEMA_ORGANIZATION_TYPE = 'Organization';
export const SCHEMA_IMAGE = '//z5staging.zeecdn.com/assets/common/Splash.jpg';
export const SCHEMA_EMAIL = 'support.in@zee5.com';
export const SCHEMA_TELEPHONE = '1800 3000 3300';
export const SCHEMA_GOOGLE_PLUS =
  'https://plus.google.com/+OZEEEntertainmentnow';
export const SCHEMA_ANDROID_PLAY_STORE =
  'https://play.google.com/store/apps/details?id=com.graymatrix.did';
export const SCHEMA_IOS_PLAY_STORE =
  'https://itunes.apple.com/in/app/zee5-shows-live-tv-movies/id743691886';
export const SCHEMA_WEBPAGE_TYPE = 'WebPage';
export const CAPTCHA_CHECK_BOX_MESSAGE = 'Please select the below check Box';

// Asset type
export const ASSET_TYPE = {
  Movie: 0,
  Episode: 1,
  Season: 2,
  Album: 3,
  ContentSet: 4,
  Track: 5,
  TvShow: 6,
  Collection: 8,
  Channel: 9,
  EpgProgram: 10,
  SubscriptionPlan: 11,
  Notification: 12,
  PromoCode: 13,
  LiveEvent: 14,
  File: 15,
  GenreList: 16,
  Unknown: 99,
  Custom: 100
};

// CHANNEL GUIDE CONSTANTS
export const CHANNEL_GUIDE_CONSTANTS = {
  CHANNEL: 'Channel',
  // DAY: "Day",
  CHANNELS: 'Channels',
  CHANNEL_GUIDE: 'Channel Guide'
};

export const SCHEMA_NAME = 'ZEE5';
export const EVENT = 'event';

export const GLOBAL_PAYMENT_PROVIDERS: GLOBAL_PAYMENT_PROVIDERS_INTERFACE = {
  simpaisa: ['mobilink', 'telenor', 'zong', 'warid'],
  cc: [
    'adyenzee5apac',
    'adyenzee5africa',
    'adyenzee5americas',
    'adyenzee5europe',
    'adyenzee5middleeast'
  ],
  mife: ['mife_celcom', 'mife_xl', 'mife_m1']
};

export interface GLOBAL_PAYMENT_PROVIDERS_INTERFACE {
  simpaisa: string[];
  cc: string[];
  mife: string[];
}

export const XACCESS_AUTHORIZATION_COOKIE_EXPIRY = 2 / 24; // Expressed in days - Equivalent to 2 hours

export const LOGIN_REGISTER_DEFAULTS = {
  emailRegex: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
  numberRegex: /(^[0-9]*$)/,
  defaultPhoneCode: '91',
  defaultDigit: '10',
  defaultMaxNumber: '10'
};

export const DISPLAY_LANGUAGE_LIST = [
  'bn',
  'de',
  'en',
  'gu',
  'hi',
  'hr',
  'id',
  'kn',
  'ml',
  'mr',
  'ms',
  'pa',
  'ru',
  'ta',
  'te',
  'th'
];

export const DEVICE_WIDTH_CONSTANTS = {
  deviceWidth600: 600,
  deviceWidth900: 900,
  deviceWidth1240: 1240,
  deviceWidth1200: 1200,
  deviceWidth1800: 1800
};

export const trueCallerProps = {
  type: 'btmsheet',
  btnShape: 'rect',
  ctaColor: '%238230c6',
  ctaPrefix: 'continuewith',
  skipOption: 'useanothernum'
};

export const INDIAN_LANGUAGES_SHORT_NAME = {
  english: 'en',
  hindi: 'hi',
  marathi: 'mr',
  gujarati: 'gu',
  bengali: 'bn',
  malayalam: 'ml',
  kannada: 'kn',
  tamil: 'ta',
  telugu: 'te',
  punjabi: 'pa',
  bhojpuri: 'hr'
};

export const TRUECALLER_KEY = 'GrHbt086bec2409db4bda9e4a6b09c44d0df3';
export const TRUECALLER_PARTNER = 'Zee5Web-Prod';
export const KEY_CODES = {
  ENTER: 'Enter',
  ARROWUP: 'ArrowUp',
  ARROWDOWN: 'ArrowDown'
};

export const TRAY_TAGS = [
  'banner',
  'continue_watching',
  'collection_with_text',
  'episodes',
  'live_title',
  'playlist',
  'live_vod',
  'portrait_small',
  'portrait_large',
  'title',
  'collection',
  'news_collection',
  'news_title',
  'channels',
  'live_tvstatic',
  'catch_up',
  'list_big',
  'live_news',
  'sameepisodelist',
  'differentepisodelist',
  'plex_widget',
  'live_channels_with_play',
  'eduauraacellstyle',
  'eduauraa_widget',
  'bg_title',
  'top10',
  'tournament_teams',
  'tournament_schedule',
  'tournament_points_table',
  'vert_banner',
  'zee5_music_entrypoint_banner'
];

export const MAX_COOKIE_AGE = 2147483647;

//used for SEO
export const assetContentMapping = {
  '0-0-1z5148987': {
    title: 'RRR ஃபுல் ஹெச்டி திரைப்படத்தை ஆன்லைனில் ZEE5ல் காணுங்கள்',
    description:
      '1920 ஆம் ஆண்டு, வீட்டிலிருந்து பிரிந்து ஆங்கிலேய அரசுக்கு எதிராக தங்களது தனிப்பட்ட ' +
      'குறிக்கோள்களுக்காக போராடும் இரு கிளர்ச்சியாளர்களை விதி ஒன்று சேர்க்கிறது.'
  },
  '0-0-1z5148988': {
    title: 'ಫುಲ್ HDಯಲ್ಲಿ RRR ಚಲನಚಿತ್ರವನ್ನು ಆನ್‌ಲೈನ್‌ನಲ್ಲಿ ವೀಕ್ಷಿಸಿ ZEE5 ನಲ್ಲಿ',
    description:
      '1920 ರಲ್ಲಿ, ತಮ್ಮ ವೈಯಕ್ತಿಕ ಉದ್ದೇಶಗಳಿಗಾಗಿ ಬ್ರಿಟಿಷ್ ಸಾಮ್ರಾಜ್ಯದ ವಿರುದ್ಧ ಹೋರಾಡುತ್ತಿರುವ ' +
      'ಕ್ರಾಂತಿಕಾರಿಗಳಾದ ರಾಮ್ ಮತ್ತು ಭೀಮ್ ಅವರನ್ನು ವಿಧಿಯು ಒಂದಾಗಿಸುತ್ತದೆ.'
  },
  '0-0-1z5148989': {
    title: 'ഓൺലൈനായി കാണൂ RRR, HD ദൃശ്യമികവിൽ നിങ്ങളുടെ ZEE5-ൽ!',
    description:
      'ബ്രിട്ടീഷ് സാമ്രാജ്യത്തിനെതിരെ കലാപത്തിനിറങ്ങിയ അല്ലൂരി സീതാരാമ രാജു, ' +
      'കോമരം ഭീം എന്നി സ്വാതന്ത്ര്യ സമരസേനാനികളുടെ ഇതിഹാസ കഥ!'
  }
};

export const kashmirFilesMovieIds = [
  '0-0-1z5141112',
  '0-0-1z5133458',
  '0-0-1z5141241',
  '0-0-1z5141243'
];

export const kashmirFilesGlobalUrlMapping = {
  '0-0-1z5141112': [
    'https://www.zee5.com/global/movies/details/the-kashmir-files-kannada/0-0-1z5141112',
    'kn-in'
  ],
  '0-0-1z5141241': [
    'https://www.zee5.com/global/movies/details/the-kashmir-files-tamil/0-0-1z5141241',
    'ta-in'
  ],
  '0-0-1z5141243': [
    'https://www.zee5.com/global/movies/details/the-kashmir-files-telugu/0-0-1z5141243',
    'te-in'
  ],
  '0-0-1z5133458': [
    'https://www.zee5.com/global/movies/details/the-kashmir-files/0-0-1z5133458',
    'hi-in'
  ]
};

export const kashmirFilesUrlMapping = {
  '0-0-1z5141112': [
    'https://www.zee5.com/movies/details/the-kashmir-files-kannada/0-0-1z5141112',
    'kn-in'
  ],
  '0-0-1z5141241': [
    'https://www.zee5.com/movies/details/the-kashmir-files-tamil/0-0-1z5141241',
    'ta-in'
  ],
  '0-0-1z5141243': [
    'https://www.zee5.com/movies/details/the-kashmir-files-telugu/0-0-1z5141243',
    'te-in'
  ],
  '0-0-1z5133458': [
    'https://www.zee5.com/movies/details/the-kashmir-files/0-0-1z5133458',
    'hi-in'
  ]
};

export const karthikeyaMovieIds = [
  '0-0-1z5227557',
  '0-0-1z5227565',
  '0-0-1z5227563'
];

export const karthikeyaGlobalUrlMapping = {
  '0-0-1z5227565': [
    'https://www.zee5.com/global/movies/details/karthikeya-2/0-0-1z5227565',
    'hi'
  ],
  '0-0-1z5227563': [
    'https://www.zee5.com/global/movies/details/karthikeya-2/0-0-1z5227563',
    'ta'
  ]
};

export const karthikeyaUrlMapping = {
  '0-0-1z5227557': [
    'https://www.zee5.com/movies/details/karthikeya-2/0-0-1z5227557',
    'en-in'
  ],
  '0-0-1z5227565': [
    'https://www.zee5.com/movies/details/karthikeya-2/0-0-1z5227565',
    'hi-in'
  ],
  '0-0-1z5227563': [
    'https://www.zee5.com/movies/details/karthikeya-2/0-0-1z5227563',
    'ta-in'
  ]
};

export const rrrMovieIds = [
  '0-0-1z5145092',
  '0-0-1z5148989',
  '0-0-1z5148988',
  '0-0-1z5148987'
];

export const rrrGlobalUrlMapping = {
  '0-0-1z5148989': [
    'https://www.zee5.com/global/movies/details/rrr-malayalam/0-0-1z5148989',
    'ml'
  ],
  '0-0-1z5148988': [
    'https://www.zee5.com/global/movies/details/rrr-kannada/0-0-1z5148988',
    'kn'
  ],
  '0-0-1z5148987': [
    'https://www.zee5.com/global/movies/details/rrr-tamil/0-0-1z5148987',
    'ta'
  ]
};

export const rrrUrlMapping = {
  '0-0-1z5145092': [
    'https://www.zee5.com/movies/details/rrr/0-0-1z5145092',
    'en-in'
  ],
  '0-0-1z5148989': [
    'https://www.zee5.com/movies/details/rrr-malayalam/0-0-1z5148989',
    'ml-in'
  ],
  '0-0-1z5148987': [
    'https://www.zee5.com/movies/details/rrr-tamil/0-0-1z5148987',
    'ta-in'
  ],
  '0-0-1z5148988': [
    'https://www.zee5.com/movies/details/rrr-kannada/0-0-1z5148988',
    'kn-in'
  ]
};

export const KARTHIKEYA_CANONICAL_GLOBAL_URL =
  'https://www.zee5.com/global/movies/details/karthikeya-2/0-0-1z5227557';

export const KARTHIKEYA_CANONICAL_URL =
  'https://www.zee5.com/movies/details/karthikeya-2/0-0-1z5227557';

export const RRR_CANONICAL_URL =
  'https://www.zee5.com/movies/details/rrr/0-0-1z5145092';

export const rangbaazWebSeriesIds = [
  '0-6-4z5173774',
  '0-6-4z5176942',
  '0-6-4z5176940'
];

export const gadarMovieID = '0-0-1z5375877';
export const gadar2MovieID = '0-0-1z5437988';
export const ghoomerMovieId = '0-0-1z5454041';
export const kadakSinghMovieId = '0-0-1z5469034';
export const tejasMovieId = '0-0-1z5489618';
export const samBahadurMovieId = '0-0-1z5500337';
export const Khichdi2MovieId = '0-0-1z5500000';
export const theKeralaStoryMovieId = '0-0-1z5512788';
export const mainAtalHoonMovieId = '0-0-1z5528544';
export const hanuManMovieId = '0-0-1z5531939';

export const rangbaazDubbedPageIds = ['0-6-4z5176942', '0-6-4z5176940'];

export const rangbaazOldWebSeriesIds = ['0-6-1322', '0-6-1320', '0-6-1138'];

export const rangbaazGlobalUrlMapping = {
  '0-6-4z5176942': [
    'https://www.zee5.com/global/web-series/details/rangbaaz-darr-ki-rajneeti-telugu/0-6-4z5176942',
    'te'
  ],
  '0-6-4z5176940': [
    'https://www.zee5.com/global/web-series/details/rangbaaz-darr-ki-rajneeti-tamil/0-6-4z5176940',
    'ta'
  ]
};

export const rangbaazUrlMapping = {
  '0-6-4z5173774': [
    'https://www.zee5.com/web-series/details/rangbaaz-darr-ki-rajneeti/0-6-4z5173774',
    'en-in'
  ],
  '0-6-4z5176942': [
    'https://www.zee5.com/web-series/details/rangbaaz-darr-ki-rajneeti-telugu/0-6-4z5176942',
    'te-in'
  ],
  '0-6-4z5176940': [
    'https://www.zee5.com/web-series/details/rangbaaz-darr-ki-rajneeti-tamil/0-6-4z5176940',
    'ta-in'
  ]
};

export const RANGBAAZ_CANONICAL_URL =
  'https://www.zee5.com/web-series/details/rangbaaz-darr-ki-rajneeti/0-6-4z5173774';

export const RANGBAAZ_CANONICAL_GLOBAL_URL =
  'https://www.zee5.com/global/web-series/details/rangbaaz-darr-ki-rajneeti/0-6-4z5173774';

export const RAKSHA_BANDHAN_CANONICAL_URL =
  'https://www.zee5.com/movies/details/raksha-bandhan/0-0-1z5228525';

export const RAKSHA_BANDHAN_CANONICAL_GLOBAL_URL =
  'https://www.zee5.com/global/movies/details/raksha-bandhan/0-0-1z5228525';

export const GADAR_CANONICAL_URL =
  'https://www.zee5.com/movies/details/gadar-ek-prem-katha/0-0-gadarekpremkatha';

export const rakshaBandhanCollectionIds = [
  '0-8-3z5197941',
  '0-8-8486',
  '0-8-manualcoll_938761592'
];

export const SPORTS_BASE_ROUTE = 'sports';
export const CRICKET_ROUTE = 'cricket/ilt20';
export const MATCH_CLIPS = 'match-clips';
export const SPORTS_ROUTE = `${SPORTS_BASE_ROUTE}/${CRICKET_ROUTE}`;

//index.js
export const INDIA_LANGUAGES_LIST = [
  'bn',
  'en',
  'gu',
  'hi',
  'hr',
  'kn',
  'ml',
  'mr',
  'pa',
  'ta',
  'te'
];
export const INTERNATIONAL_LANGUAGES_LIST = [
  ...INDIA_LANGUAGES_LIST,
  'th',
  'id',
  'ms',
  'ru',
  'de'
];

// pageNames
export enum PageNameEnums {
  CHANNEL_DETAILS_PAGE = 'channelDetailPage',
  TV_CHANNEL_DETAILS = 'tvchannelDetail'
}

// Consumption page string constants
export const CONSUMPTION_PAGE_STRING_CONSTANTS = {
  EPISODE: 'Episode',
  TVEPISODE: 'TVEpisode',
  SHARE: 'Share',
  WATCHLIST: 'Watchlist',
  CAST: 'Cast',
  WATCH_TRAILER: 'Watch Trailer',
  AUDIO_LANGUAGE: 'Audio Language',
  LANGUAGE: 'language',
  SUBTITLES: 'Subtitles',
  AVAILABLE: 'Available in',
  MORE_EPISODES: 'More Episodes',
  MOVIES: 'Movies',
  CREATORS: 'Creators',
  DIRECTOR: 'Director',
  MUSIC_DIRECTOR: 'Music Director',
  EMBED: 'Embed',
  EMBED_VIDEO: 'Embed Video',
  EMBED_FRAMEBORDER_TEXT1: `<iframe width="560" height="315" src="${ZEE5_BASE_ADDRESS}/zee5embed?contentId=`,
  EMBED_FRAMEBORDER_TEXT2: `&autoplay=true" frameBorder="0" allow="autoplay;encrypted-media" allowFullScreen />`,
  EMBED_START_TIME: 'Start at',
  FAVOURITES: 'Favourites',
  NA: 'NA',
  PERSONALIZED: 'Personalized',
  CONSUMPTIONPAGE: 'consumptionPage'
};

// player integration

//Mandatory registration popup
export const MANDATORY_REGISTRATION = {
  NUMBER_OF_CONTENTS_IN: 2,
  NUMBER_OF_CONTENTS: 5
};

// conviva custom tags
export const convivaCustomConstants = {
  NOT_APPLICABLE: 'Not-Applicable',
  NOT_RECEIVED: 'Not-Received',
  UNKNOWN: 'Unknown',
  CLICK_SOURCE: 'Internal-ZEE5-InApp',
  LIVE: 'Live',
  VOD: 'VOD',
  GUEST: 'Guest',
  DRM: 'DRM',
  HLS: 'HLS',
  DEFAULT_PARTNER_ZEE5: 'ZEE5',
  AUTHENTICATED: 'Authenticated',
  PREMIUM: 'Premium',
  DEFAULT_RESOURCE: 'AMAZON',
  PLAYER_NAME: 'Web-Zee5',
  WEB: 'WEB',
  PWA: 'PWA',
  ORGANIC: 'Organic',
  DEFAULT_EFFECTIVE_TYPE: '4g',
  WIFI: 'WiFi',
  NO_EXPERIMENTS: 'No-Experiments',
  ZEE5: 'Zee5',
  PLAN_ID: 'planID',
  MANUAL: 'Manual',
  LANGUAGE_CHANGE: 'Language Change',
  SEASON1: 'S1',
  SPORTS_KEYMOMENTS: 'Sports_KeyMoments',
  ON: 'On',
  OFF: 'Off',
  DRM_SECURITY_SAFARI: 'Apple FairPlay',
  DRM_SECURITY_OTHER_BROWSERS: 'Google Widevine Modular L3',
  VENDOR: 'vendor',
  VERSION: 'version',
  MODEL: 'model',
  FUNC_TYPE: 'function',
  MOBILE: 'mobile',
  UNDEF_TYPE: 'undefined',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
  TYPE: 'type'
};

// conviva ILt analytics related
export const LIVE_EVENT = 'live_event';
export const SPORTS_VOD = 'sports_vod';

export const CANONICAL_URLS = {
  GLOBAL: {
    RRR: RRR_CANONICAL_URL,
    KARTHIKEYA: KARTHIKEYA_CANONICAL_GLOBAL_URL,
    RANGBAAZ: RANGBAAZ_CANONICAL_GLOBAL_URL,
    RAKSHA_BANDHAN: RAKSHA_BANDHAN_CANONICAL_GLOBAL_URL
  },
  INDIA: {
    RRR: RRR_CANONICAL_URL,
    KARTHIKEYA: KARTHIKEYA_CANONICAL_URL,
    RANGBAAZ: RANGBAAZ_CANONICAL_URL,
    RAKSHA_BANDHAN: RAKSHA_BANDHAN_CANONICAL_URL,
    GADAR: GADAR_CANONICAL_URL
  }
};

export enum ContentLangugaBannerEnums {
  SESSION_VALUE = 'sessionValue',
  CONTENT_BANNER = 'contentBanner',
  NO_OF_VISIBILITY = 2,
  SESSION_VALUE_FOR_LOGGED_IN = 'sessionValueForLoggedIn',
  VISBILITY_COUNT = 'content_language_widget_visible_count',
  MAX_VISBILITY_COUNT = 3
}

export const TERMS_LINK = '/termsofuse';

export const CURRENCY_SYMBOLS = {
  RUPEE: '₹',
  DOLLAR: '$'
};
export const SCROLL_OFFSET =
  typeof window === 'undefined' ? 500 : window.innerWidth < 400 ? 100 : 500;
export enum API_STATUS_TYPES {
  idle = 'idle',
  loading = 'loading',
  success = 'success',
  failure = 'failure'
}
export const assetsForNoIndexNoFollow =
  /(0-0-1z5347314|0-0-1z5347357|0-0-1z5347342|0-0-1z5347316|0-0-1z5347321|0-0-1z5347294|0-0-1z5347296|0-0-1z5347298|0-0-1z5347300|0-0-1z5347324|0-0-1z5347302|0-0-1z5347338|0-0-1z5347333|0-0-1z5347329|0-0-1z5347328|0-0-1z5347325|0-0-1z5347331|0-0-1z5347304|0-0-1z5347320|0-0-1z5347336|0-0-1z5347306|0-0-1z5347308|0-0-1z5347310|0-0-1z5347317|0-0-1z5347339|0-0-1z5347312|0-0-1z5347343|0-0-1z5351464)$/gi;
/**
"0-0-1z5419278: Raksha Bandhan"
"0-0-1z5419264: Bangarraju"
"0-0-1z5419265: Bimbisara"
"0-0-1z5419266: Chhatriwali"
"0-0-1z5419267: Chup: Revenge of the Artist"
"0-0-1z5419268: undefined"
"0-0-1z5419269: Garuda Gamana Vrishabha Vahana"
"0-0-1z5419272: Janhit Mein Jaari "
"0-0-1z5419273: Karthikeya 2"
"0-0-1z5419274: Lost"
"0-0-1z5419275: Love Hostel"
"0-0-1z5419276: RRR"
"0-0-1z5419277: Vedha"
"0-0-1z5419278: Raksha Bandhan"
 */
export const assetsForNoIndex =
  /(0-0-1z5419278|0-0-1z5419264|0-0-1z5419265|0-0-1z5419266|0-0-1z5419267|0-0-1z5419268|0-0-1z5419269|0-0-1z5419272|0-0-1z5419273|0-0-1z5419274|0-0-1z5419275|0-0-1z5419276|0-0-1z5419277|0-0-1z5419278|0-0-1z537587)$/i;

export enum AgeRatings {
  'U' = '0',
  'U/A' = '13',
  'A' = '18'
}

export enum FeatureFlagConstants {
  FEATURE_RECENT_SEARCH = 'feature_recent_search',
  FEATURE_TOP_SEARCH = 'feature_top_search',
  FEATURE_SEARCH_SUGGESTION = 'feature_search_suggestion',
  CONFIG_SEARCH_QUERY_LENGTH = 'config_search_query_length',
  FEATURE_USER_REACTION = 'feature_user_reaction',
  FEATURE_PREMIUM_LOGO = 'feature_premium_logo',
  FEATURE_ZEE_PLEX_LOGO = 'feature_zeeplex_logo',
  FEATURE_SEO_CONSUMPTION_RAILS = 'feature_consumption_seo_rails',
  FEATURE_CUSTOM_RAIL_FEATURING = 'feature_custom_rail_featuring',
  FEATURE_CONVIVA_APP_ANALYTICS = 'feature_app_analytics',
  FEATURE_CELEB_PROFILE = 'feature_celeb_profile',
  FEATURE_SUBSCRIPTION_NUDGE_ENABLED = 'feature_subscription_enable_nudge',
  FEATURE_UPNEXT_API = 'feature_upnext_latest_api',
  // HAMBURGER
  FEATURE_NFT_FLAG = 'feature_nft_flag',
  CONFIG_REFERRAL = 'config_referral',
  CONFIG_SPORTS = 'config_sports',
  //HAMBURGER, FOOTER
  FEATURE_BLOG_LINK = 'feature_show_blog_link',
  FEATURE_BLOG_LINK_GLOBAL = 'feature_show_blog_link_global',
  //Player
  CONFIG_CONSUMPTION_SUBSCRIPTION_NUDGE = 'config_consumption_subscription_nudge',
  CONFIG_CONTINUE_WATCHING_RAIL_FOR_GUEST_USER = 'config_continue_watching_for_guest_user',
  FEATURE_GUEST_SUBSCRIPTION_JOURNEY = 'feature_guest_sub_journey',
  CONFIG_COMMERCE = 'config_commerce',
  FEATURE_NEW_SEARCH_REVAMP_LANDING = 'feature_new_search_revamp_landing',
  FEATURE_ONBOARDING_FOR_SUBSCRIBED_USER = 'feature_onboarding_for_subscribed_user',
  FEATURE_DETAILS_PAGE_CONTINUE_WATCHING = 'feature_details_page_continue_watching',
  FEATURE_BINGE_OFFER = 'feature_binge_offer',
  FEATURE_META_PIXEL_INTEGRATION = 'feature_meta_pixel_integration',
  FEATURE_NEW_SUBSCRIPTION_UI = 'feature_new_subscription_ui',
  FEATURE_FOOTER_THROUGH_API = 'feature_footer_through_api',
  CONFIG_SEO_URL = 'config_seo_urls',
  CONFIG_KNOW_YOUR_TEAM = 'config_know_your_team',
  FEATURE_SEO_THROUGH_API = 'feature_seo_through_api'
}

export enum SubscriptionFlowType {
  SUBSCRIPTION = 'SUBSCRIPTION',
  UPGRADE = 'UPGRADE'
}

export enum footerTextTypeEnums {
  CHILD_FOOTER_SHOWS = 'child-footer-show',
  CHILD_FOOTER_MOVIES = 'child-footer-movies',
  CHILD_FOOTER_SERIES = 'child-footer-series',
  CHILD_FOOTER = 'child-footer',
  MEGA_MENU_FOOTER = 'mega-menu-footer'
}

export const REMOTE_CONFIG = 'remote_config';
export const USER_LOCATION_DATA = 'user_location_data';
export const APP_CONFIG = 'app_config';
export const INITIAL_LAUNCH = 'inital_launch';
export const EPISODE_TRANSLATION = 'episode_translation';

export enum SubscriptionFallbackEnums {
  FEATURE = '/webapp-assets/images/pack_fallback_icon.svg',
  CONTEXT_BANNER = '/webapp-assets/images/context-banner.png'
}
